module.exports = __webpack_public_path__ + "img/pro_two_2.58bd2541.jpg";